import ClipCard from "./ClipCard";

export default ClipCard;
